export default {"src":"/_next/static/media/shipping5.d5c27c4f.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};